module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0130.jpg?v=c8da9659";